import classNames from "classnames";
import styles from "./index.module.scss";
import MainTitle from "@/components/MainTitle";
import { Col, Row } from 'antd';
import eggUrl from "@/assets/images/about/earth.png";
import intl from "react-intl-universal";
const Intro = () => {
	return (
		<div className={classNames('container', styles.introBox)}>
			<h1>{intl.get("WHO WE ARE")}</h1>
			<p>{intl.get("About.whoDes")}</p>
			{/* <Row gutter={60} align="middle">
				<Col span={12}>
					<div className={styles.leftBox}>
						<MainTitle title="WHO WE ARE" />
						<p>{intl.get("About.whoDes")}</p>
					</div>
				</Col>
				<Col span={12}>
					<div className={styles.rightBox}>
						<img src={eggUrl} />
					</div>
				</Col>
			</Row> */}
		</div>
	)
}
export default Intro